import { render, staticRenderFns } from "./ResultsPage.vue?vue&type=template&id=73bcf041&scoped=true&lang=pug&"
import script from "./ResultsPage.vue?vue&type=script&lang=js&"
export * from "./ResultsPage.vue?vue&type=script&lang=js&"
import style0 from "./ResultsPage.vue?vue&type=style&index=0&id=73bcf041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bcf041",
  null
  
)

export default component.exports